import { render, staticRenderFns } from "./VrstaSkupaCreate.vue?vue&type=template&id=69dbc24c&scoped=true&"
import script from "./VrstaSkupaCreate.vue?vue&type=script&lang=js&"
export * from "./VrstaSkupaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dbc24c",
  null
  
)

export default component.exports